import React, { lazy, Suspense } from 'react';
import { isLocal } from '../../Services/helpers';
import API from '../../Services/API';

/**
 * Cheap, always-mounted gate for the local-first dev tool.
 *
 * Only a local super admin loads the (Dexie-backed) {@link SyncDevTool}, so the
 * whole local-first stack stays in a lazily-loaded chunk instead of the main
 * bundle for everyone else. Imports here are deliberately light (isLocal + API).
 */

const SyncDevTool = lazy(() => import('./SyncDevTool'));

const SyncDevToolGate = () => {
    if (!(isLocal() && API.isAdmin('Super'))) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <SyncDevTool />
        </Suspense>
    );
};

export default SyncDevToolGate;
